import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setBatteryInfoObject, setBatteryState, setBatteryValue, setShowLowBatteryMsg } from "../../reducers/battery-network-info-reducer";
import useLanguageChange from "../../hooks/useLanguageChange";
import { CALL_DATA, PublicVariables } from "../../constants/PublicVariables";
import { getParticipantIndex } from "../../shared/dataTrackFunction";
import batteryInfoService from "../../services/batteryInfoService";
import { setIsMobileSessionInfoVisible } from "../../reducers/common-reducer";
import { AR_MARKUP_VIEW, EXTRACT_TEXT_VIEW, MARKUP_VIEW } from "../../constants/Constants";

const DeviceBattery = () => {
    const dispatch = useDispatch();
    const localisedValues = useLanguageChange();
    const { isLocalDeviceBatteryLow, lowBatteryParticipanteId, showLowBatteryMsg } = useSelector((state) => state.batteryNetworkInfo);
    const { isRemoteParticipantJoined, expandView, newActiveUserList } = useSelector((state) => state.commonReducer);
    const { markupInprogress, arMarkupLiveStream, markupLiveStream } = useSelector((state) => state.markup);
    const { extractTextInprogress } = useSelector((state) => state.extractText);

    const handleCloseLowBatteryPopup = () => {
        dispatch(setShowLowBatteryMsg(false));

        if (PublicVariables.isMobile) {
            dispatch(setIsMobileSessionInfoVisible(true));
        }
    };

    useEffect(() => {
        if (!isRemoteParticipantJoined) return;

        let batteryFun;
        let batteryObject;
        // device battery related function
        setTimeout(() => {
            if (navigator.getBattery !== undefined) {
                navigator.getBattery().then((batteryObj) => {
                    const object = {
                        charging: batteryObj.charging,
                        chargingTime: batteryObj.chargingTime,
                        dischargingTime: batteryObj.dischargingTime,
                        level: batteryObj.level,
                    };

                    dispatch(setBatteryInfoObject(object));
                    const level = object?.level * 100 + "%";
                    dispatch(setBatteryValue(level));
                    if (object.charging === true) {
                        dispatch(setBatteryState("Charging"));
                    } else {
                        dispatch(setBatteryState("Discharging"));
                    }

                    batteryInfoService.setBatteryObject(batteryObj);
                    batteryObject = batteryObj;

                    batteryFun = batteryInfoService.callBatteryFunction();
                    batteryFun();
                    batteryObj.addEventListener("levelchange", batteryFun, false);
                });
            }
        }, 2500);

        return () => {
            if (batteryObject) batteryObject.removeEventListener("levelchange", batteryFun, false);
        };
    }, [isRemoteParticipantJoined]);

    const BodyText = useMemo(() => {
        let text = "";
        if (isLocalDeviceBatteryLow) {
            text = localisedValues["device_battery_low"];
        } else {
            if (lowBatteryParticipanteId !== CALL_DATA.localIdentity) {
                text = (
                    <>
                        <span className='device-participant-name'> {getParticipantIndex(lowBatteryParticipanteId)} </span> -
                        {localisedValues["device_battery_low"]}
                    </>
                );
            }
        }

        return text;
    }, [isLocalDeviceBatteryLow, lowBatteryParticipanteId, newActiveUserList]);

    return (
        <>
            {showLowBatteryMsg &&
                getParticipantIndex(lowBatteryParticipanteId) &&
                expandView &&
                markupInprogress === MARKUP_VIEW.OFF_VIEW &&
                arMarkupLiveStream === AR_MARKUP_VIEW.OFF_VIEW &&
                extractTextInprogress === EXTRACT_TEXT_VIEW.OFF_VIEW &&
                !markupLiveStream && (
                    <div className='device-notification'>
                        <div className='device-notification-box'>
                            <div className='device-notification-in'>
                                <div className='device-notification-icon'>
                                    <span className='for-icon icon-low-battery'></span>
                                </div>
                                <div className='device-notification-text'>{BodyText}</div>
                            </div>
                            <div className='device-notification-close'>
                                <button className='btn close-btn' onClick={handleCloseLowBatteryPopup}>
                                    <span className='btn-icon icon-close'></span>
                                </button>
                            </div>
                        </div>
                    </div>
                )}
        </>
    );
};

export default DeviceBattery;
